var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_pos-r",
      attrs: { "data-qa": `project-engagement-card-ID:${_vm.orderID}` },
    },
    [
      _c("balloon-actions", {
        staticClass: "gfu-box__balloon _z-1",
        attrs: {
          actions: _vm.balloonActions,
          "balloon-style-props": _vm.balloonStyleProps,
          theme: "lightOutline",
          mode: _vm.balloonActionsModes.grouped,
          "data-qa": "pledge-card:Actions",
        },
      }),
      _vm._v(" "),
      _c(
        "box",
        { attrs: { mute: _vm.isMuted } },
        [
          _vm.hasAction
            ? _vm._l(_vm.mappedActions, function (action) {
                return _c(
                  "project-action-notificator",
                  _vm._b(
                    {
                      key: action.actionLabel,
                      on: { "action-dismiss": _vm.handleActionDismiss },
                    },
                    "project-action-notificator",
                    action,
                    false
                  )
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "backer-center-pledge-card-header",
            _vm._b(
              {},
              "backer-center-pledge-card-header",
              { ..._vm.$props },
              false
            )
          ),
          _vm._v(" "),
          _c("order-statuses-list", {
            staticClass: "_my-3",
            attrs: {
              "order-stage": _vm.stage,
              "payment-status": _vm.paymentStatus,
              "project-phase": _vm.projectPhase,
            },
          }),
          _vm._v(" "),
          _c(
            "backer-center-pledge-card-additional-info",
            _vm._b(
              {},
              "backer-center-pledge-card-additional-info",
              { ..._vm.$props },
              false
            )
          ),
          _vm._v(" "),
          _vm.isPaymentHistoryModalOpen
            ? _c("pledge-payment-history-modal", {
                attrs: {
                  "is-open": _vm.isPaymentHistoryModalOpen,
                  "order-id": _vm.orderID,
                  "pledge-id": _vm.orderPublicID,
                },
                on: { "action-close": _vm.onPaymentHistoryModalClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isOrderStageHistoryModalOpen
            ? _c("order-stage-history-modal", {
                attrs: {
                  "is-open": _vm.isOrderStageHistoryModalOpen,
                  "order-public-id": _vm.orderPublicID,
                  "order-id": _vm.orderID,
                },
                on: { "action-close": _vm.onOrderStageHistoryModalClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }